module.exports = __webpack_public_path__ + "img/gsport.67a3c2a.webp";